export const upper = s => {
    s = s.trim();
    return s.charAt(0).toUpperCase() + s.substring(1);
};
